import politicalStatusFactory from './politicalStatusFactory';

export default politicalStatusFactory({
    prefix: 'data.political.family',
    title: 'Une personne de votre famille ou de votre entourage exerce-t-elle ou a-t-elle exercé depuis moins ' +
        'd’un an une fonction politique, juridictionnelle ou administrative importante ?',
    fromRelationship: true,
});
